import { environment } from '../../../environments/environment';
import { AnalyticsEffects } from '../analytics/analytics.effects';
import { AnnouncementEffects } from '../announcements/announcements.effects';
import { ChatsEffects } from '../chats/chats.effects';
import { CheckInTagsEffects } from '../check-in-tags/check-in-tags.effects';
import { CheckInsEffects } from '../check-ins/check-ins.effects';
import { ConversationsEffects } from '../conversations/conversations.effects';
import { KratosCoreEffects } from '../core/core-kratos.effects';
import { CustomerFilesEffects } from '../customer-files/customer-files.effects';
import { CustomerListsEffects } from '../customer-lists/customer-lists.effects';
import { CustomerTeamEffects } from '../customer-team/customer-team.effects';
import { CustomersEffects } from '../customers/customers.effects';
import { DataExportEffects } from '../data-export/data-export.effects';
import { FeedEffects } from '../feed/feed.effects';
import { FeedbackEffects } from '../feedback/feedback.effects';
import { FileUploadEffects } from '../file-upload/file-upload.effects';
import { FilesEffects } from '../files/files.effects';
import { InviteEffects } from '../invite/invite.effects';
import { LocationEffects } from '../location/location.effects';
import { MemberCustomersEffects } from '../member-customers/member-customers.effects';
import { MemoCategoryEffects } from '../memo-categories/memo-categories.effects';
import { MemoriamEffects } from '../memoriams/memoriams.effects';
import { MemosEffects } from '../memos/memos.effects';
import { NotificationsEffects } from '../notifications/notifications.effects';
import { OrganisationEffects } from '../organisations/organisations.effects';
import { ProfileEffects } from '../profile/profile.effects';
import { QuestionsEffects } from '../questions/questions.effects';
import { ReleaseNotesEffects } from '../release-notes/release-notes.effects';
import { RemoteConfigEffects } from '../remote-config/remote-config.effects';
import { RequestsEffects } from '../requests/requests.effects';
import { RouterEffects } from '../router/router.effects';
import { SettingsEffects } from '../settings/settings.effects';
import { SnackBarEffects } from '../snackbar/snackbar.effects';
import { StaffCustomerEffects } from '../staff-customers/staff-customers.effects';
import { MembersEffects } from '../members/members.effects';
import { StatisticsEffects } from '../statistics/statistics.effects';
import { StorageSyncEffects } from '../storage-sync/storage-sync.effects';
import { TenantsEffects } from '../tenants/tenants.effects';
import { RelatedDataEffects } from './related-data.effects';
import { MarketManagementEffects } from '../market-management-category/market-management-category.effects';

import { authEffects } from '../auth/auth.effects';
import { CelebrationEffects } from '../celebration/celebration.effects';
import { MemberBadgeEffects } from '../member-badges/member-badges.effects';
import { EventsEffects } from '../events/events.effects';
import { StreamEffects } from '../stream/stream.effects';
import { EnquiriesEffects } from '../../enquiries/store/enquiries.effects';
import { EnquiriesTenantCategoriesEffects } from '../../enquiries/store/tenant-categories/enquiries-tenant-categories.effects';
import { EnquiriesTenantSettingsEffects } from '../../enquiries/store/tenant-settings/enquiries-tenant-settings.effects';

export const EFFECTS = [
  AnalyticsEffects,
  AnnouncementEffects,
  ...authEffects,
  KratosCoreEffects,
  CelebrationEffects,
  ChatsEffects,
  CheckInsEffects,
  CheckInTagsEffects,
  ConversationsEffects,
  CustomerFilesEffects,
  CustomersEffects,
  CustomerTeamEffects,
  CustomerListsEffects,
  DataExportEffects,
  EnquiriesEffects,
  EnquiriesTenantCategoriesEffects,
  EnquiriesTenantSettingsEffects,
  EventsEffects,
  FeedbackEffects,
  FeedEffects,
  FileUploadEffects,
  FilesEffects,
  InviteEffects,
  LocationEffects,
  MarketManagementEffects,
  MemberBadgeEffects,
  MemberCustomersEffects,
  MemoCategoryEffects,
  MemoriamEffects,
  MemosEffects,
  NotificationsEffects,
  OrganisationEffects,
  ProfileEffects,
  RelatedDataEffects,
  RemoteConfigEffects,
  RequestsEffects,
  ReleaseNotesEffects,
  RouterEffects,
  SettingsEffects,
  SnackBarEffects,
  StaffCustomerEffects,
  MembersEffects,
  StatisticsEffects,
  StorageSyncEffects,
  StreamEffects,
  TenantsEffects,
  QuestionsEffects,
];
